import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { Maybe } from "../../sharedCode/avroGraphql";
import { getHelperText, propertyHasErrors } from "./inputHelpers";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { StringCustomControlProps } from "../../Utils/Interfaces";

function limitValue(value: string | null | undefined, maxLength?: number): string {
    const next = value ?? "";
    return maxLength != null ? next.slice(0, maxLength) : next;
}

export default function StringEditor(props: StringCustomControlProps): JSX.Element {
    const [localValue, setLocalValue] = useState<Maybe<string>>(limitValue(props.initialValue ?? "", props.maxLength));

    return (
        <>
            <TextField
                disabled={props.isDisabled}
                margin={CONTROL_MARGIN}
                fullWidth
                label={props.labelText}
                value={localValue ?? ""}
                onChange={(e) => {
                    handleOnChange(e.target.value);
                }}
                onBlur={(e) => {
                    handleOnBlur(e.target.value);
                }}
                inputProps={{
                    style: { textTransform: "uppercase" },
                    ...(props.maxLength != null ? { maxLength: props.maxLength } : {}),
                }}
                error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
            />
        </>
    );

    function handleOnChange(value: string | null): void {
        setLocalValue(limitValue(value, props.maxLength));
    }

    function handleOnBlur(value: string | null): void {
        const limited = limitValue(value, props.maxLength);
        if (limited !== (props.initialValue ?? "")) {
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: limited.toLocaleUpperCase() });
        }
    }
}
